import { format, isDate } from 'date-fns';

const textareaSplit = (text = '', isSplitSpace) =>
  text.split ? trimText(text).split(isSplitSpace ? /[\n\t ]+/ : /[\n\t]+/) : text;

const extractSelectBoxKey = (selectedItem) => selectedItem?.key ?? selectedItem;

const isOnlyArrayValues = (itemList) => !!itemList?.filter && itemList.length > 0 && !itemList[0].key;

const extractCheckboxGroupKey = (itemList) => {
  if (isOnlyArrayValues(itemList)) {
    return itemList;
  }

  return itemList?.filter?.(({ checked }) => checked)?.map?.(({ key }) => key) ?? itemList;
};

const trimText = (text) => (text?.trim ? text.trim() : text);

export const dateFormatter = (date) => (isDate(date) ? format(date, 'yyyyMMddHHmmss') : date);

const dateStartedToFormatedNumber = (value) => {
  if (value != null && value.length > 0) {
    return value.substr(0, 8) + '-' + value.slice(8);
  }
};

export const toBusinessNumberForamt = (number) => {
  if (number && number.length === 10) {
    return number.substr(0, 3) + '-' + number.substr(3, 2) + '-' + number.substr(5);
  } else return number;
};

export const toPhoneNumberFormat = (number) => {
  if (number && number.length === 11) {
    return number.substr(0, 3) + '-' + number.substr(3, 4) + '-' + number.substr(7);
  } else return number;
};
export const reform = {
  textarea: textareaSplit,
  selectBox: extractSelectBoxKey,
  text: trimText,
  checkboxGroup: extractCheckboxGroupKey,
  date: dateFormatter,
  dateStartedToFormatedNumber: dateStartedToFormatedNumber,
};

export const extractForm = (value) => {
  const selectBox = reform.selectBox(value);
  const checkboxGroup = reform.checkboxGroup(selectBox);
  const date = reform.date(checkboxGroup);
  return reform.text(date);
};
